// Campaigns Index - Alpine.js Component
// Handles campaign listing with dropdown menus and delete functionality

document.addEventListener('alpine:init', () => {

    Alpine.data('campaigns_index_x_data', () => ({
        // Dropdown states
        dropdownStates: {},
        // Expand/collapse states for campaign rows
        expandedCampaigns: {},
        // Search functionality
        searchQuery: '',
        searchTimeout: null,

        init() {
            // Initialize dropdown states
            this.dropdownStates = {};
            // Initialize expanded campaigns
            this.expandedCampaigns = {};
            // Initialize search query from URL params
            const urlParams = new URLSearchParams(window.location.search);
            this.searchQuery = urlParams.get('query') || '';
            
            // Add document click listener to close dropdowns when clicking outside
            document.addEventListener('click', (e) => {
                // Check if click is outside any dropdown
                const isDropdownClick = e.target.closest('.campaign-actions-dropdown');
                const isToggleClick = e.target.closest('button[title="More options"]');
                
                if (!isDropdownClick && !isToggleClick) {
                    // Close all dropdowns if clicking outside
                    Object.keys(this.dropdownStates).forEach(id => {
                        this.dropdownStates[id] = false;
                    });
                }
            });
        },

        // Dropdown management
        toggle_dropdown(campaignId) {
            // Close all other dropdowns first
            Object.keys(this.dropdownStates).forEach(id => {
                if (id !== campaignId) {
                    this.dropdownStates[id] = false;
                }
            });

            // Toggle the clicked dropdown
            this.dropdownStates[campaignId] = !this.dropdownStates[campaignId];
        },

        close_dropdown(campaignId) {
            this.dropdownStates[campaignId] = false;
        },

        is_dropdown_open(campaignId) {
            return this.dropdownStates[campaignId] || false;
        },

        // Expand/collapse management
        toggle_campaign_expand(campaignId) {
            this.expandedCampaigns[campaignId] = !this.expandedCampaigns[campaignId];
        },

        is_campaign_expanded(campaignId) {
            return this.expandedCampaigns[campaignId] || false;
        },

        // Search functionality
        performSearch() {
            // Clear existing timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }
            
            // Set new timeout for 200ms debounce
            this.searchTimeout = setTimeout(() => {
                this.searchCampaigns();
            }, 200);
        },

        async searchCampaigns() {
            try {
                // Get show ID from template data
                const showId = this.$refs.campaign_index_template_data.dataset.showId;
                if (!showId) {
                    console.error('Show ID not found in template data');
                    return;
                }

                // Build search URL with current status filter
                const urlParams = new URLSearchParams(window.location.search);
                const status = urlParams.get('status') || '';
                
                let searchUrl = `/shows/${showId}/campaigns/search?query=${encodeURIComponent(this.searchQuery)}`;
                if (status) {
                    searchUrl += `&status=${encodeURIComponent(status)}`;
                }

                // Make search request
                const response = await fetch(searchUrl, {
                    method: 'GET',
                    headers: {
                        'Accept': 'text/html',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });

                if (response.ok) {
                    const html = await response.text();
                    // Update the campaigns table container
                    document.getElementById('campaigns-table-container').innerHTML = html;
                } else {
                    console.error('Search request failed:', response.status);
                }
            } catch (error) {
                console.error('Error performing search:', error);
            }
        },

        // Campaign actions
        delete_campaign(campaignId, campaignName) {
            let that = this;

            if (confirm(`Are you sure you want to delete "${campaignName}"? This action cannot be undone.`)) {
                // Close the dropdown immediately
                this.close_dropdown(campaignId);
                
                // Get show_id from template data
                const showId = that.$refs.campaign_index_template_data.dataset.showId;
                if (!showId) {
                    console.error('Show ID not found in template data');
                    alert('Error: Show ID not found. Please try again later.');
                    return;
                }

                // Get CSRF token with fallback
                const csrfToken = document.querySelector('meta[name="csrf-token"]').content

                // Make API call to delete the campaign
                fetch(`/shows/${showId}/campaigns/${campaignId}`, {
                    method: 'DELETE',
                    headers: {
                        'X-CSRF-Token': csrfToken,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => {
                        if (response.ok) {
                            // Reload the page to reflect the deletion
                            window.location.reload();
                        } else {
                            return response.json().then(data => {
                                alert(`Failed to delete campaign: ${data.message || 'Unknown error'}`);
                            });
                        }
                    })
                    .catch(error => {
                        console.error('Error deleting campaign:', error);
                        alert('Error deleting campaign. Please try again.');
                    });
            } else {
                // If user cancels, also close the dropdown
                this.close_dropdown(campaignId);
            }
        },

        archive_campaign(campaignId, campaignName) {
            let that = this;

            if (confirm(`Are you sure you want to archive "${campaignName}"? This will move the campaign to the archived status.`)) {
                // Close the dropdown immediately
                this.close_dropdown(campaignId);
                
                // Get show_id from template data
                const showId = that.$refs.campaign_index_template_data.dataset.showId;
                if (!showId) {
                    console.error('Show ID not found in template data');
                    alert('Error: Show ID not found. Please try again later.');
                    return;
                }

                // Get CSRF token with fallback
                const csrfToken = document.querySelector('meta[name="csrf-token"]').content

                // Make API call to archive the campaign
                fetch(`/shows/${showId}/campaigns/${campaignId}/archive`, {
                    method: 'PATCH',
                    headers: {
                        'X-CSRF-Token': csrfToken,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => {
                        if (response.ok) {
                            // Reload the page to reflect the archive action
                            window.location.reload();
                        } else {
                            return response.json().then(data => {
                                alert(`Failed to archive campaign: ${data.message || 'Unknown error'}`);
                            });
                        }
                    })
                    .catch(error => {
                        console.error('Error archiving campaign:', error);
                        alert('Error archiving campaign. Please try again.');
                    });
            } else {
                // If user cancels, also close the dropdown
                this.close_dropdown(campaignId);
            }
        },
    }));
});
